import type { ControlAuditByIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetControlAuditByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetControlAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetControlAuditByIdArgs = {
  id: string;
};

export const useGetControlAuditById = createQueryHook<
  UseGetControlAuditByIdArgs,
  ControlAuditByIdResponseRow[],
  GetControlAuditByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getControlAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ control_audit: data }),
  graphqlDocument: GetControlAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
